export default [
  {
    path: "/cryptoConfigurations/cashInMethods",
    component: () => import(/* webpackChunkName: "cashInMethods.layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "crypto.cashInMethods.show",
        component: () => import(/* webpackChunkName: "crypto.cashInMethods" */ "./show.vue"),
      },
    ],
  },
];
